import { render, staticRenderFns } from "./PersonaMoral.vue?vue&type=template&id=3847360d&"
import script from "./PersonaMoral.vue?vue&type=script&lang=js&"
export * from "./PersonaMoral.vue?vue&type=script&lang=js&"
import style0 from "./PersonaMoral.vue?vue&type=style&index=0&id=3847360d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports